import ModalConfirmComponent from 'components/modal-confirm'

interface DeleteStudentComponentProps {
  isShow: boolean
  studentId: string
  onActionCancel: () => void
  onActionSubmit: (userId?: string) => void
}

const DeleteStudentComponent = ({ isShow, studentId, onActionCancel, onActionSubmit }: DeleteStudentComponentProps) => {
  const handleDeleteUser = async () => {
    onActionSubmit(studentId)
  }
  return (
    <ModalConfirmComponent
      isShow={isShow}
      title={`Remove User?`}
      body={`User will lose access to your school community`}
      actionIcon={'redInfoIcon'}
      actionText={'Confirm'}
      onActionCancel={onActionCancel}
      onActionSubmit={handleDeleteUser}
      data_testid='remove-user-testid'
    />
  )
}

export default DeleteStudentComponent
